import { create } from "zustand";

interface Draft {
  text: string;
  mediaKey: string | null;
}

interface ComposerState {
  drafts: Record<string, Draft>;
  setText: (scope: string, text: string) => void;
  setMedia: (scope: string, mediaKey: string | null) => void;
  clear: (scope: string) => void;
}

export const useComposerStore = create<ComposerState>((set) => ({
  drafts: {},
  setText: (scope, text) =>
    set((state) => ({
      drafts: {
        ...state.drafts,
        [scope]: {
          ...(state.drafts[scope] ?? { mediaKey: null }),
          text,
        },
      },
    })),
  setMedia: (scope, mediaKey) =>
    set((state) => ({
      drafts: {
        ...state.drafts,
        [scope]: {
          ...(state.drafts[scope] ?? { text: "" }),
          mediaKey,
        },
      },
    })),
  clear: (scope) => set((state) => {
    const drafts = { ...state.drafts };
    delete drafts[scope];
    return { drafts };
  }),
}));
